import request from '@/utils/request'

export function getCrmConfig(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/crm.getCrmConfig',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取CRM配置失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function uploadOwnerToCrm(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/crm.uploadOwnerToCrm',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '上载业主到CRM失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function testCrmConnection(crmUrl) {
  return new Promise((resolve, reject) => {
    const timeout = 3000
    let timedOut = false
    const timer = setTimeout(() => {
      timedOut = true
      reject(new Error('连接超时'))
    }, timeout)
    fetch(crmUrl, { method: 'GET', mode: 'no-cors' })
      .then(() => {
        clearTimeout(timer)
        if (!timedOut) {
          resolve()
        }
      })
      .catch(err => {
        clearTimeout(timer)
        if (!timedOut) {
          reject(err)
        }
      })
  })
}

export function listCrmUploadLogs(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/crm.listCrmUploadLogs',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取CRM上载日志失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}